import { useAuth0 } from "@auth0/auth0-react"
import { useEffect } from "react"
import { appApi, useGetIotCredsQuery } from "../app/apis/appApi"
import { useAppDispatch, useAppSelector } from "../app/hooks/hooks"
import { setConfig } from "../app/slices/wsSlice"
import { wsService } from "../utils/WebSocketService"

export const useWebSocket = () => {
  const { isAuthenticated } = useAuth0()
  const dispatch = useAppDispatch()

  const { data, isLoading, error } = useGetIotCredsQuery(undefined, {
    skip: !isAuthenticated,
  })
  const wsConfig = data?.data ?? null
  const wsState = useAppSelector((state) => state.ws)

  useEffect(() => {
    wsService.setDispatch(dispatch)
    wsService.setApi(appApi)
    wsService.setRefetchConfig(async () => {
      const result = await dispatch(
        appApi.endpoints.getIotCreds.initiate(undefined, {
          forceRefetch: true,
        }),
      ).unwrap()
      return result?.data ?? null
    })
  }, [dispatch])

  useEffect(() => {
    if (wsConfig && !wsState.config) {
      const configWithTopics = {
        ...wsConfig,
        topics: [],
      }
      dispatch(setConfig(configWithTopics as any))
      wsService.connect(configWithTopics)
    }
  }, [wsConfig, wsState.config, dispatch])

  useEffect(() => {
    return () => {
      wsService.disconnect()
    }
  }, [])

  return {
    wsState,
    isLoading,
    error,
    reconnect: () => wsConfig && wsService.connect(wsConfig),
    disconnect: () => wsService.disconnect(),
  }
}
